import { ButtonProps } from "@origin-digital/ods-core";
import { ActionSectionProps } from "./types";
import React from "react";
import { useNavigate } from "react-router-dom";
import { FilterButtonProps } from "src/components/Premises/FilterButton/types";

export const useActionSection = (props: ActionSectionProps) => {
  const navigate = useNavigate();

  const newPremisesButtonProps: Partial<ButtonProps> = React.useMemo(() => {
    return {
      onClick: () => {
        navigate("/new-premise");
      },
      "data-id": "actionSection.newPremisesButton",
    };
  }, [navigate]);

  const claimDBRequestButtonProps: Partial<ButtonProps> = React.useMemo(() => {
    return {
      onClick: () => {
        props.openClaimDialog();
      },
      "data-id": "actionSection.claimDBRequestButton",
    };
  }, [props.openClaimDialog]);

  const filterButtonProps: FilterButtonProps = React.useMemo(() => {
    return {
      badge: {
        count: props.filtersCount,
      },
      onClick: () => props.openFilterDialog(),
      "data-id": "actionSection.filterButton",
    };
  }, [props.filtersCount, props.openFilterDialog]);
  return {
    newPremisesButtonProps,
    claimDBRequestButtonProps,
    filterButtonProps,
  };
};
